import {makeAutoObservable} from "mobx";
import {AMOUNT_TYPE, FEE_TYPES_REQUIRING_AMOUNT_INPUT, FEE_TYPE, IPolicyFee} from "../../policies/policy-types";
import { ICRMAFeeDto } from "../../../models/User";

export interface IRMAFeeDto extends Partial<IPolicyFee>{
	is_charged: boolean;
	charge_tax: boolean;
	fee_type?: FEE_TYPE | null;
	amount_type: AMOUNT_TYPE;
	amount: number;
}

class RmaFeeStore {
	private _model:IRMAFeeDto;

	/** the seed is absent until the store settings have loaded, so treat it as fully optional */
	constructor(defaults: Partial<ICRMAFeeDto> = {}) {
		makeAutoObservable(this, {}, { autoBind: true });
		this._model = {
			...defaults,
			is_charged: defaults.is_charged ?? false,
			charge_tax: defaults.charge_tax ?? false,
			amount_type: defaults.amount_type ?? AMOUNT_TYPE.FIXED,
			amount: defaults.amount ?? 0,
		};
	}

	public resetStore(): void {
		this.setCharged(false);
		this.setIsChargeTax(false);
		this.setAmountType(AMOUNT_TYPE.FIXED);
        this.setAmount(0);
		this.setFeeType(null);
	};
    
 
	
	public get hasEditableAmount(): boolean {
		if (!this.feeType) {
			return false;
		}
		return !([FEE_TYPE.COST_PLUS_SHIPMENT_FEE, FEE_TYPE.SHIPMENT_FEE].includes(this.feeType));
	}
	public get hasPercentageAmount(): boolean {
		if (!this.hasEditableAmount) {
			return false;
		}
		return this.amountType === AMOUNT_TYPE.ITEM_PERCENTAGE_PAID_PRICE ||
			this.amountType === AMOUNT_TYPE.ITEM_PERCENTAGE_CATALOG_PRICE;
	}
	
	get isChargeTax(): boolean { return this._model.charge_tax; }
	get isCharged(): boolean { return this._model.is_charged; }
	get feeType(){ return this._model.fee_type; }
	get amountType(){ return this._model.amount_type; }
	get amount(){ return this._model.amount; }
	get showAmountOptions() {
		return (
			this.feeType == null || FEE_TYPES_REQUIRING_AMOUNT_INPUT.includes(this.feeType)
		);
	}
	
	setCharged(value: boolean) { this._model.is_charged = value; }
	setIsChargeTax(value: boolean) { this._model.charge_tax = value; }
	setAmountType(value: AMOUNT_TYPE) { this._model.amount_type = value;}
	setAmount(value: number){ this._model.amount = value; }
	
	setFeeType(value: FEE_TYPE | null) {
        this._model.fee_type = value;
        if (value === FEE_TYPE.SHIPMENT_FEE) {
            this._model.amount_type = AMOUNT_TYPE.FIXED;
        }
    }
	
	requestModel(){ return {...this._model}; }
}

export default RmaFeeStore;